module.exports = __webpack_public_path__ + "img/icon-ppt.bae2d43c.svg";